import api from '../utils/baseUrl'
import {UserObject, UserAuthObject} from '../utils/types';

class AuthService {
    async login(user: UserAuthObject) {
        return await api.post('/auth/login', user);
    }

    async signUp(user: UserObject) {
        return await api.post('/auth/signup', user);
    }

    async setPassword(object: { email: string, password: string }) {
        return await api.post('/auth/setPassword', object);
    }

    async forgotPassword(identifier: UserAuthObject) {
        return await api.post('/auth/forgotPassword', identifier);
    }

    async verifyAccount(token: string | null, type: string | null) {
        return await api.get(`/auth/verifyAccount?token=${token}&type=${type}`);
    }

    async resetPassword(object: { newPassword: string, token: string }) {
        return await api.post(`/auth/resetPassword`, object);
    }

    async logout() {
        return await api.post(`/api/logout`);
    }

    async regenerateVerificationLink(email: object) {
        return await api.post(`/auth/regenerateVerificationLink`, email);
    }

    async switchRole(activeRole: string) {
        return await api.get(`/auth/switchRole/${activeRole}`);
    }

    async getProfile() {
        return await api.get(`/auth/profile`);
    }

    async updateProfile(payload: {
        username: string;
        userType: string;
        profile?: { firstName: string; lastName: string; phone?: string };
        businessInfo?: {
            companyName: string;
            companyWebsite?: string;
            vatNumber?: string;
            companyAddress?: string;
            phone?: string;
        };
        bio?: string;
        numberOfFollowers?: number;
        links?: {
            url: string;
            type: 'facebook' | 'instagram' | 'x' | 'tiktok' | 'linkedin' | 'youtube' | 'twitch';
        }[];
    }) {
        return await api.put('/auth/profile', payload);
    }

    async updatePassword(payload: { oldPassword: string; newPassword: string; }) {
        return await api.put('/auth/profile/password', payload);
    }

    async updateUserSocials(payload: {
        bio: string;
        numberOfFollowers?: number;
        links: {
            url: string;
            type: 'facebook' | 'instagram' | 'x' | 'tiktok' | 'linkedin' | 'youtube' | 'twitch';
        }[];
    }) {
        return await api.put('/auth/profile/socials', payload);
    }
}

export default new AuthService()